import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faWhatsapp,
	faFacebook,
	faInstagram,
	faThreads,
	faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

import {
	faArrowRight,
	faArrowLeft,
	faCheck,
	faTriangleExclamation,
	faPhone,
	faEnvelope,
	faXmark,
	faLocationDot,
	faCircleCheck,
	faThumbsUp,
	faFaceGrin,
	faCircleUser,
	faHeart,
	faHandSparkles,
	faPenToSquare,
	faRocket,
	faCalendarDays,
	faPersonCircleCheck,
	faShieldHeart,
	faPercent,
	faLightbulb,
	faPersonShelter,
	faUserPen,
	faHeartCirclePlus,
	faBandage,
	faWaveSquare,
	faArrowsToDot,
	faDumbbell,
	faTape,
	faHandHoldingMedical,
	faBabyCarriage,
	faPersonRunning,
	faHands,
	faMapLocation,
	faArrowRightFromBracket,
	faPencil,
	faGraduationCap,
	faHandshakeSimple,
	faPersonCircleQuestion,
	faRoute,
	faCommentMedical,
	faGift,
	faBolt,
	faCircleQuestion,
	faUpRightFromSquare,
	faGears,
	faAngleLeft,
	faAngleRight,
	faChevronDown,
	faInfo,
	faInfoCircle,
	faCopy,
	faArrowsRotate,
	faRankingStar,
	faPeopleGroup,
	faBars,
	faArrowTurnDown,
	faUsersRectangle,
	faVolleyball,
	faHandshakeAngle,
	faPeopleRoof,
	faPlus,
	faChevronRight,
	faPenRuler,
	faSackDollar,
	faClock,
	faBusinessTime,
	faUserTie,
	faArrowTurnUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const icons = {
	faArrowRight,
	faArrowLeft,
	faCheck,
	faTriangleExclamation,
	faPhone,
	faEnvelope,
	faXmark,
	faLocationDot,
	faCircleCheck,
	faThumbsUp,
	faFaceGrin,
	faCircleUser,
	faHeart,
	faHandSparkles,
	faPenToSquare,
	faRocket,
	faCalendarDays,
	faPersonCircleCheck,
	faShieldHeart,
	faPercent,
	faLightbulb,
	faPersonShelter,
	faUserPen,
	faHeartCirclePlus,
	faBandage,
	faWaveSquare,
	faArrowsToDot,
	faDumbbell,
	faTape,
	faHandHoldingMedical,
	faBabyCarriage,
	faPersonRunning,
	faHands,
	faMapLocation,
	faArrowRightFromBracket,
	faWhatsapp,
	faFacebook,
	faInstagram,
	faThreads,
	faPencil,
	faGraduationCap,
	faHandshakeSimple,
	faPersonCircleQuestion,
	faRoute,
	faCommentMedical,
	faGift,
	faBolt,
	faCircleQuestion,
	faUpRightFromSquare,
	faGears,
	faAngleLeft,
	faAngleRight,
	faChevronDown,
	faInfo,
	faInfoCircle,
	faCopy,
	faArrowsRotate,
	faPeopleGroup,
	faRankingStar,
	faBars,
	faXTwitter,
	faArrowTurnDown,
	faUsersRectangle,
	faPenRuler,
	faVolleyball,
	faHandshakeAngle,
	faPeopleRoof,
	faPlus,
	faChevronRight,
	faSackDollar,
	faClock,
	faBusinessTime,
	faUserTie,
	faArrowTurnUp,
};

type CamelToSnake<T extends string, P extends string = ''> = string extends T
	? string
	: T extends `${infer C0}${infer R}`
		? CamelToSnake<R, `${P}${C0 extends Lowercase<C0> ? '' : '-'}${Lowercase<C0>}`>
		: P;

type CamelizeKeys<T extends object> = {
	[key in keyof T as key extends string ? CamelToSnake<key> : key]: T[key]
};

export type FontAwesomeIconType = keyof CamelizeKeys<typeof icons>;

library.add(icons);

export default defineNuxtPlugin({
	name: 'fontawesome',
	parallel: true,
	setup: (nuxtApp) => {
		nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon);
	},
});
